import { HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { RefreshSessionService } from '@services/refresh-session.service';
import { AUTH_URLS } from '@shared/config/url.config';
import { LocalStorageService } from '@shared/services/local-storage.service';
import { catchError, switchMap } from 'rxjs/operators';
import { throwError } from 'rxjs';

export const sessionTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const refreshSessionService = inject(RefreshSessionService);
  let hasRetriedRequest = false;

  const executeRequestWithUnauthorizedRetry = () =>
    next(req).pipe(
      catchError(err => {
        if (err.status !== HttpStatusCode.Unauthorized || hasRetriedRequest) {
          return throwError(() => err);
        }

        hasRetriedRequest = true;

        return refreshSessionService.refreshInternalToken().pipe(
          switchMap(() => next(req)),
          catchError(refreshErr => throwError(() => refreshErr))
        );
      })
    );

  // Catch authentication routes to not trigger token expiration
  if (AUTH_URLS.some(authUrl => req.url.includes(authUrl))) {
    return next(req);
  }

  if (
    LocalStorageService.isLoggedIn() &&
    (refreshSessionService.isInternalTokenRefreshing() ||
      refreshSessionService.isInternalTokenExpired())
  ) {
    return refreshSessionService.refreshInternalToken().pipe(
      switchMap(() => executeRequestWithUnauthorizedRetry()),
      catchError(err => throwError(() => err))
    );
  }

  return executeRequestWithUnauthorizedRetry();
};
